import { getId, Icon, List, Modal, PrimaryButton } from "@fluentui/react";
import ModalHeaderView from "../../common/views/ModalHeaderView";
import { StyleUtils } from "../../common/views/StyleUtils";
import { Utils } from "../../common/views/Utils";
import { EditPictureModel } from "../models/PictureModel";
import PictureInputView from "./PictureInputView";

type EditPictureListProps = {
    pictures: EditPictureModel[];
    loading: boolean;
    onValueChange: <K extends keyof EditPictureModel>(
        id: number, field: K, value: EditPictureModel[K]) => void;
    onEditList: () => void;
    onClose: () => void;
}

export default function EditPictureListView({
    pictures, loading, onValueChange, onEditList, onClose
}: EditPictureListProps) {
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    const column = Utils.getColumnWidth(2);

    const printHeader = () => {
        return <div className="ms-Grid-row font-bold pv-10">
            <div className={column}></div>
            <div className={column}>Category</div>
            <div className={column}>Type</div>
            <div className={column}>Order</div>
            <div className={column}>Collage Order</div>
            <div className={column}>Is Primary</div>
        </div>
    }

    const onRenderRow = (picture?: EditPictureModel, index?: number) => {
        if (!picture) { return <></>; }

        return <>
            <PictureInputView
                picture={picture}
                index={index ?? 0}
                onValueChange={onValueChange} />
        </>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={true}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(800)}
        >
            <div className="popup-header">
                <ModalHeaderView title="Edit Pictures" onClose={onClose} />
            </div>
            <div id={subtitleId} className="popup-body">
                <div className="ms-Grid">
                    {printHeader()}
                    <List items={pictures} onRenderCell={onRenderRow} />
                </div>

                {!loading && <div className="ms-Grid-row center pv-20">
                    <PrimaryButton onClick={onEditList}>Submit</PrimaryButton>
                </div>}
            </div>
        </Modal>
    </>
}